import ApexCharts from 'apexcharts'
import { Controller } from '@hotwired/stimulus';
import consumer from "../channels/consumer"
import I18n from 'i18n-js/index.js.erb'
import { shapeSeries } from '../helpers/telemetry_series'
export default class extends Controller {
  static targets = ['field','sensor','chartContainer']
  connect() {
    let locale = document.querySelector('.current_locale')
    I18n.locale = locale ? locale.dataset.locale : 'en'
    I18n.currentLocale();
    let width = this.element.clientWidth || this.element.parentElement?.clientWidth || 400
    let container = this.buildContainer(width)
    this.element.appendChild(container)
    let format = this.getFormat(this.element.dataset.format, this.element.dataset.sensor)
    let data = this.fetchData(format)
    let ref = this.element.dataset.ref
    let element = this.element
    this.chart = this.renderChart(container, format.defaultOptions(ref, format, element, execUpdateSeries))
    updateChart(this.chart, format.getOptions(), data)
    if (!this.element.dataset.flag) {
      this.subscription = this.subscribeChat(ref, format, this.chart, element)
    }
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  fetchData(format, data) {
    let sensor = this.element.dataset.sensor
    let name = this.element.dataset.name
    let sensors = sensor.split(',')
    let names = name.split(',')
    const states = ( data == null) ? JSON.parse(this.element.dataset.states) : data
    let lastLife = states[states.length-1] == undefined ? 0 :  states[states.length-1].lifes
    if(sensor === 'live'){return [{ name: I18n.t('js.lifespan'), data: lastLife }]}

    return shapeSeries(states, sensors, names)
  }

  getFormat(name, sensor) {
    if(name === 'CA1' || name === 'RP1' || name === 'TA1'){let Format = require(`../formats/${name.toLowerCase()}_format`).default
    return new Format()}
    let Format = require(`../formats/${name.toLowerCase()}_${sensor}_format`).default
    
    return new Format()
  }

  renderChart(container, options, data = {}) {
    let chart = new ApexCharts(container, options)
    chart.render()
    return chart
  }

  buildContainer(width) {
    let container = document.createElement('div')
    container.setAttribute('width', width)
    container.setAttribute('height', (width*9/16))

    return container
  }

  subscribeChat(ref, format, chart, element){
    return consumer.subscriptions.create(
      {channel: 'SensorChannel',
      sensor_ref: ref}, 
      {
        connected() {
        },
      
        disconnected() {
          // Called when the subscription has been terminated by the server
        },
      
        received(data) {
          updateChartData(format, chart, ref, element)
        }
      });
  }
}

const updateChartData = (format, chart, ref, element, startDate = null, endDate = null) => {
  startDate
  fetch(`/api/v1/telemetries/get_sensor_telemetries?sensor_ref=${ref}&start_date=${startDate}&end_date=${endDate}`)
  .then(response => response.json())
  .then(data => { 
    let newData = fetchData(format, data, element)
    updateChart(chart, format.getOptions(), newData)
   })
}

const fetchData = (format, data, element) => {
  let sensor = element.dataset.sensor
  let name = element.dataset.name
  let sensors = sensor.split(',')
  let names = name.split(',')
  const states = ( data == null) ? JSON.parse(element.dataset.states) : data
  let lastLife = states[0] == undefined ? 0 :  states[0].lifes
  if(sensor === 'live'){return [{ name: 'Vida útil', data: lastLife }]}

  return shapeSeries(states, sensors, names)
}

const updateChart = (chart, newOptions = null, newSeries = null) => {
  if(newOptions === null && newSeries === null) { return }
  if(newOptions === null && newSeries !== null) {
    // v5 rompió updateSeries (no recalcula eje/marcadores al pasar de series
    // vacías a pobladas). updateOptions({series:}) sí lo hace y es compatible
    // con v3.54. Ver TELEPAK_V2 0.8.
    return chart.updateOptions({ series: newSeries })
  }
  if(newOptions !== null && newSeries === null) {
    return chart.updateOptions(newOptions)
  }
  newOptions.series = newSeries
  chart.updateOptions(newOptions)
}

const execUpdateSeries = (ref, startDate, endDate, format, element, chartId) => {
  fetch(`/api/v1/telemetries/get_sensor_telemetries?sensor_ref=${ref}&start_date=${startDate}&end_date=${endDate}`)
  .then(response => response.json())
  .then(data => { 
    let newData = fetchData(format, data, element)
    let payload = []
    if(chartId === 'ca1'){
      payload.push({name: I18n.t('js.chart.current_pressure'), data: newData[0]['data']});
      payload.push({name: I18n.t('js.chart.set_pressure'), data: newData[1]['data']});
    } 
    else if(chartId === 'ta1'){
      payload.push({name: I18n.t('js.chart.input_height'), data: newData[0]['data']});
      payload.push({name: I18n.t('js.chart.output_height'), data: newData[1]['data']});
    }
    else {
      payload.push({data: newData[0]['data']});
    }
    // v5: updateSeries roto; usar updateOptions con la nueva serie (path de zoom/reset).
    ApexCharts.exec(chartId, 'updateOptions', { series: payload });
  })
}
